<template>
  <div>
    <header v-if="$c('show_profile_welcome_title') || $c('show_profile_picture')" class="profile-title" :class="brandClass()">
        <div class="container-profile-picture-and-qr">

            <div v-if="$c('show_profile_welcome_title') || $c('show_profile_picture')" class="profile-picture-wrapper">
                <div class="chartContainer" :class="{'pointer':!editDisabled && !isLoading && $c('enable_profile_picture_edit')}">
                  <div v-if="$c('show_qr_section')" @keydown="ariaClick" tabindex="0" role="button" class="qr-desktop" :class="[{'pointer':!editDisabled && !isLoading && $c('enable_profile_picture_edit')}, brandClass()]" id="show_alert_qr_code" @click="!isLoading && showAlertQrCode()">
                    </div>
                    <div class="chart" id="graph">
                        <div v-if="$c('show_profile_picture')" class="profile-title-picture" id="profile-title-picture" @click="!editDisabled && openPictureUploadPopup()">
                            <img v-if="!profileImg" src="~@/assets/default/light/placeholder-profile-picture-default-light.svg" alt="">
                            <img v-else :src="profileImg" alt="">
                        </div>
                    </div>
                    <div v-if="$c('show_profile_picture') && $c('enable_profile_picture_edit') && !editDisabled" @keydown="ariaClick" tabindex="0" role="button" class="picture-edit additional-hitbox" @click="!editDisabled && openPictureUploadPopup()" :class="{'pointer':!editDisabled}" id="upload_picture_button" :aria-label="$t('profile_edit_profile_picture')">
                    </div>
                </div>
                <div v-if="isProfilePercentageBarEnabled && $c('show_profile_picture')" class="picture-label">
                    <span id="tooltip-label">{{profile_completion_message}}</span>
                    <OneTippy :brandClass="brandClass()" :name="'pictureInfoTrigger'" v-if="true" :placement="'top-start'" :maxWidth="300" :labelledBy="'tooltip-label'">
                        <template v-slot:externalcontent>
                            <div class="tooltip-title">{{$t("profile_picture_completion_update_label")}}</div>
                            <span class="tooltip-body">{{$t("profile_picture_completion_tooltip_message")}}</span>
                        </template>
                    </OneTippy>
                </div>
            </div>
        </div>


        <div class="profile-title-text" v-if="$c('show_profile_welcome_title')">
            <h1 class="profile-title-welcome">
                {{$t("profile_header_welcome_prefix")}}{{welcomeName}}{{$t("profile_header_welcome_suffix")}}
            </h1>
            <div class="profile-title-content">{{$t("profile_header_subtitle")}}</div>
        </div>


    </header>

    <!-- PROFILE PICTURE UPLOAD POPUP -->
    <OneAlert 
      v-if="isPictureUploadPopupOpened" 
      class="picture_upload_popup" 
      :brandClass="brandClass()" 
      :title="$t('profile_picture_popup_title')" 
      :content="$t('profile_picture_popup_subtitle')" 
      :button_confirm_label="changePictureButtonLabel ? $t('profile_picture_popup_delete_picture_button') : $t('profile_picture_popup_upload_picture_button')"
      :button_confirm_disabled="isProfilePictureButtonDisabled" 
      :button_cancel_label="$t('profile_cancel_button')" 
      @confirm="changePictureButtonLabel ? deleteProfilePicture() : uploadProfilePicture()" 
      @close="closePictureUploadPopupClicked">
        <template v-slot:internal-content>
          <profile-picture-upload
                :triggerLoadImage="triggerLoadImage"
                :userProfileImage="profileImg"
                @imageLoaded="profileImageLoaded($event)"
                @changeLabel="changeImageLoaderButtonLabel()"
                @enableUploadButton="isProfilePictureButtonDisabled = false"
          ></profile-picture-upload>
        </template>
    </OneAlert>

    <!-- QR ALERT-->
    <OneAlert :brandClass="brandClass()" v-if="showQrAlert" :title="$t('profile_qr_popup_title')" :content="$t('profile_qr_popup_subtitle')" :button_confirm_disabled="false" @close="closeQrAlert()">
        <template v-slot:internal-content>
            <div class="qr-code-container">
              <QRCodeVue3
                  v-if="!isLoading && qrImage"
                  :width="200"
                  :height="200"
                  :value="qrValue"
                  :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
                  :image="qrImage"
                  :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 3, crossOrigin: 'Anonymous' }"
                  backgroundColor="white"
                  :dotsOptions="{
                    type: 'square',
                    color: 'black',
                  }"
                  :backgroundOptions="{ color: '#ffffff' }"
                  :cornersSquareOptions="{ type: 'square', color: '#000000' }"
                  :cornersDotOptions="{ type: 'square', color: '#000000' }"
              />
            </div>
            <div>{{$t('profile_qr_popup_content')}}</div>
        </template>
    </OneAlert>
  </div>

</template>
<style lang="scss">

    .profile-title {
      height: 312px;
      align-items: center;
      text-align: left;
      display: flex;
      background: white;
      
      &.__d{
        .profile-picture-wrapper {
          .picture-edit {
            background-image: url('~@/assets/default/dark/update-default-dark.svg');
          }
        }
      }
        
      .profile-picture-wrapper {
        width: 30%;
        .chartContainer {
            position: relative;
            width: 128px;
            height: 128px;
            //margin: auto;
            .chart {
                width: 128px;
                height: 128px;
                position: relative;
            }
            canvas {
                width: 128px;
            }
        }
        
        .picture-edit {
            position: absolute;
            background-image: url('~@/assets/default/light/update-default-light.svg');
            width: 12px;
            height: 20px;
            left: 115px;
            top: 115px;
            &:hover {
                outline: auto;
            }
        }
        .qr-desktop {
            position: absolute;
            background-image: url('~@/assets/default/light/qr-default-light.svg');
            width: 30px;
            height: 30px;
            left: 125px;
            display: block;
            &:hover {
                outline: auto;
            }
            &.__d {
                background-image: url('~@/assets/default/dark/qr-default-dark.svg');
            }
        }
        .picture-label {
            margin-top: 25px;
            width: 300px;
            @media (min-width: 769px) and (max-width: 1024px){
              width: 165px;
            }
            @media (min-width: 1025px) and (max-width: 1159px){
              width: 190px;
            }
            @media (min-width: 1160px) and (max-width: 1286px){
              width: 220px;
            }
            @media (min-width: 1287px) and (max-width: 1410px){
              width: 260px;
            }
            .picture-text {
                margin-left: 15px;
                font-weight: bold;
            }
            .picture-text-no-margin {
                font-weight: bold;
            }
            .picture-info {
                background-image: url('~@/assets/default/light/info-default-light.svg');
                width: 11px;
                height: 11px;
                background-repeat: no-repeat;
                margin-left: 10px;
                background-size: cover;
                display: inline-block;
                &:focus {
                    // outline:  none;
                }
            }
        }
        .profile-title-picture {
            width: 116px;
            height: 116px;
            display: inline-block;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            border-radius: 50%;
            overflow: hidden;
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
      }
      .profile-title-text {
        top: 9px;
        display: inline-block;
        width: 55%;
        //margin-left: 24px;
        .profile-title-welcome {
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0px;
            text-transform: uppercase;
            font-weight: 300;
            font-size: 48px;
            line-height: 64px;
        }
        .profile-title-content {
            font-size: 16px;
            line-height: 24px;
        }
      }

      &.__alphabet{
        .profile-picture-wrapper {
          .picture-edit {
            width: 10px;
            height: 10px;
            background-repeat: no-repeat;
            background-image: url('~@/assets/alphabet/light/update-alphabet-light.svg');
          }
        }
      }

      &.__motorrad {
        .profile-picture-wrapper .picture-edit {
          background-image: url('~@/assets/motorrad/light/update-motorrad-light.svg');
        }

        &.__d {
          .profile-picture-wrapper .picture-edit {
            background-image: url('~@/assets/default/dark/update-default-dark.svg');
          }
        }
      }
        
      &.__m {
        &.__d{
          .profile-picture-wrapper {
            .picture-edit {
              background-image: url('~@/assets/mini/dark/edit-mini-dark.svg');
            }
          }
        }
        .profile-picture-wrapper {
            .picture-edit {
                position: absolute;
                background-image: url('~@/assets/mini/light/edit-mini-light.svg');
                width: 20px;
                height: 20px;
                left: 115px;
                top: 115px;
                background-repeat: no-repeat;
                background-size: 75%;
            }
            .picture-label {
                font-family: MINISansSerif;
                font-size: 12px;
                color: $minimenu;
                display: flex;
                .picture-text {
                    font-weight: bold;
                }
                .picture-text-no-margin {
                    font-weight: bold;
                }
                .picture-info {
                    background-image: url('~@/assets/mini/light/info-grey-mini-light.svg');
                    width: 14px;
                    height: 14px;
                }
            }
        }
        .profile-title-text {
            .profile-title-welcome {
                font-weight: 700;
                font-size: 50px;
                line-height: 50px;
            }
            .profile-title-content {
                font-size: 18px;
                line-height: 24px;
                margin-top: 10px;
            }
        }
      }

      &.__t {
        .profile-title-text {
          .profile-title-welcome {
              font-family: ToyotaSemibold;
          }
        }
      }

      &.__alphera {
        .profile-title-text {
            .profile-title-welcome {
                font-family: TahomaAlpheraBold;
            }
        }
      }

      &.__alphabet {
        .profile-title-text {
          .profile-title-welcome {
              text-transform: none;
              color: $alphabetblue;
              font-family: AlphabetSlabPro-Light;
              font-weight: 100;
          }
          .profile-title-content {
              color: $alphabetblue;
              font-family: AlphabetSansPro-Medium;
              font-weight: 100;
          }
        }
      }

      &.__rr {
        background: transparent;

        .profile-title-text {
          .profile-title-welcome {
              text-transform: uppercase;
              color: white;
              font-family: RivieraNights-Light;
          }
          .profile-title-content {
              color: rgba(white, 0.6);
              font-family: RivieraNights-Ultralight;
          }
        }

        .profile-picture-wrapper {
          color: rgba(white, 0.6);
          font-family: RivieraNights-Ultralight;

          .picture-edit{
            background-image: url('~@/assets/default/dark/update-default-dark.svg');
          }
        }
      }

      &.__d {
        &.__alphabet {
          .profile-title-text {
            .profile-title-welcome {
                color: white;
            }
            .profile-title-content {
                color: white;
            }
          }
        }
      }
    }

    .container-profile-picture-and-qr {
      width: 30%;
      padding-left: 7%;
      display: flex;
      justify-content: left;
    }

    .qr-code-container {
      margin: 20px;
      background-color: white;
      img{
        display: initial;
      }
    }


    //small desktop
    @media screen and (max-width: 1024px) {
      .profile-title {
          margin-left: 7%;
          margin-right: 7%;
          .profile-picture-wrapper {
              padding-left: 0;
          }
          .profile-title-text {
              width: auto;
          }
      }
    }


    @media screen and (max-width: 768px) {
        .container-profile-picture-and-qr {
          width: 50%;
          margin: auto;
          text-align: center;
          padding-left: 0;
        }
        .profile-title {
            display: block;
            height: auto;
            margin: 40px 0;
            .profile-picture-wrapper {
                width: 100%;
                margin: auto;
                text-align: center;
                .chartContainer {
                    margin: 0 auto;
                }
                .picture-label {
                    width: auto;
                }
            }
            .profile-title-picture {
                display: block;
            }
            .profile-title-text {
                display: block;
                margin-left: 7%;
                margin-right: 7%;
                margin-top: 39px;
                position: relative;
                .profile-title-welcome {
                    font-size: 32px;
                    line-height: 40px;
                }
                .profile-title-content {
                    margin-top: 10px;
                    font-size: 14px;
                    line-height: 20px;
                }
            }


        &.__m {
            display: block;
            height: auto;
            margin: 40px 0;
            .profile-picture-wrapper {
                .picture-label {
                    display: block;
                }
                width: 100%;
                margin: auto;
                text-align: center;
                .chartContainer {
                    margin: 0 auto;
                }
                .picture-label {
                    width: auto;
                }
            }
         }
      }
  }



</style>
<script>
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import QRCodeVue3 from "qrcode-vue3";
import ProfilePictureUpload from "@/components/ProfileForm/components/ProfilePictureUpload.vue";
import { defineAsyncComponent } from 'vue'

export default {
  inject:['$c', '$t', 'brandClass', 'assetSource'],
  name: "ProfileHeader",
  //validations from vuelidate
  mixins: [oneUtils.accessibilityMixin],
    components: {
    ProfilePictureUpload,
    QRCodeVue3,
    OneTippy: defineAsyncComponent(() =>
      import('../../../../gcdm-one-library/gcdm-one-tippy/src/OneTippy')
    )
},
  props: {
    user: {},
    editDisabled: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    triggerLoadImage: false,
    profile_completion_message: '',
    isPictureUploadPopupOpened: false,
    changePictureButtonLabel: false,
    isLoading: false,
    profileImg: null,
    isProfilePictureButtonDisabled: true,
    showQrAlert: false,
    qrImage: null,
    qrValue: null,
    croppedImg: null,
  }),
  computed: {
    // name to display on the top
    welcomeName() {
      if (this.user) {
        if (this.user.nickname) return this.user.nickname.trim();
        if (this.user.firstName) return this.user.firstName.trim();
      }
      return "";
    },
    brand() {
      const brand = this.$store.state.configurationParams.brand || oneUtils.properties.DEFAULT_FALLBACK_BRAND;

      switch(brand) {
        case "mini": return "MINI"
        case "rr": return "RR"
        case "alphabet": return "ALPHABET"
        case "alphera": return "ALPHERA"
        case "bmwmotorrad": return "BMW_MOTORRAD"
        case "toyota": return "TOYOTA"
        case "bmw":
        default: return "BMW"
      }
    },
    //enambled percentage bar
    isProfilePercentageBarEnabled(){
      const isPercentageBarEnabledGlobal = this.$c("show_profile_percentage_bar_global");
      const isPercentageBarEnabledClient = this.$c("show_profile_percentage_bar");
      if (isPercentageBarEnabledGlobal && isPercentageBarEnabledClient !== undefined) {
           return isPercentageBarEnabledGlobal && isPercentageBarEnabledClient;
      }
      return isPercentageBarEnabledGlobal;
    },
    // percentage value
    completitionPercentage() {
      const user = this.user;     
      // PERSONAL DATA SECTION - START
      const addresses = this.user.addresses;
      const emails = this.user.communications && this.user.communications.communicationEMails ? this.user.communications.communicationEMails : [];
      const phones = this.user.communications && this.user.communications.communicationPhones ? this.user.communications.communicationPhones : [];
      // PERSONAL INFORMATION - START
      const personalInformationConfig = this.$c('_profileConfiguration').personalDataSection;
      let personalInformationTotal = 0;
      let personalInformationCompletition = 0;
      Object.keys(personalInformationConfig).forEach(field => {
        const fieldPriority = this.getPriorityValue(personalInformationConfig[field].priority);
        personalInformationTotal += fieldPriority;
        if (user[field]) personalInformationCompletition += fieldPriority;
      });
      const personalInformationUnit = 100 / personalInformationTotal;
      const personalInformationPercentage = personalInformationCompletition * personalInformationUnit;
      // PERSONAL INFORMATION - END

      // ADDRESS - START
      // const addressesDataConfig = this.$c('_profileConfiguration').addressesSection;
      // let addressesDataTotal = 0;
      // let addressesDataCompletition = 0;
      // addresses.forEach(address => {
      //   Object.keys(addressesDataConfig).forEach(field => {
      //     const fieldPriority = getPriorityValue(addressesDataConfig[field].priority);
      //     addressesDataTotal += fieldPriority;
      //     console.log('completitionPercentage - field: ', field, addressesDataConfig[field].priority, fieldPriority, address[field], !!address[field]);
      //     if (address[field]) addressesDataCompletition += fieldPriority;
      //   });
      // });
      // const addressesDataUnit = 100 / addressesDataTotal;
      // const addressesDataPercentage = addressesDataCompletition * addressesDataUnit;
      // console.log('completitionPercentage - addressesDataTotal: ', addressesDataTotal);
      // console.log('completitionPercentage - addressesDataCompletition: ', addressesDataCompletition);
      // console.log('completitionPercentage - addressesDataUnit: ', addressesDataUnit);
      // console.log('completitionPercentage - addressesDataPercentage: ', addressesDataPercentage);
      let addressesDataPercentage = 0;
      if (addresses && addresses.length !== 0) addressesDataPercentage = 100;
      // ADDRESS - END

      // EMAIL - START
      // const emailDataConfig = this.$c('_profileConfiguration').comunicationEmail;
      // let emailDataTotal = 0;
      // let emailDataCompletition = 0;
      // emails.forEach(email => {
      //   // email value
      //   let fieldPriority = getPriorityValue(emailDataConfig['email'].priority);
      //   emailDataTotal += fieldPriority;
      //   console.log('completitionPercentage - field: ', 'email', emailDataConfig['email'].priority, fieldPriority, email.value, !!email.value);
      //   if (email.value) emailDataCompletition += fieldPriority;
      //   // email type //TODO: check if  "communicationType" is the right value
      //   fieldPriority = getPriorityValue(emailDataConfig['emailType']);
      //   emailDataTotal += fieldPriority;
      //   console.log('completitionPercentage - field: ', 'emailType', emailDataConfig['emailType'], fieldPriority, email.communicationType, !!email.communicationType);
      //   if (email.communicationType) emailDataCompletition += fieldPriority;
      // });
      // const emailDataUnit = 100 / emailDataTotal;
      // const emailDataPercentage = emailDataCompletition * emailDataUnit;
      // console.log('completitionPercentage - emailDataTotal: ', emailDataTotal);
      // console.log('completitionPercentage - emailDataCompletition: ', emailDataCompletition);
      // console.log('completitionPercentage - emailDataUnit: ', emailDataUnit);
      // console.log('completitionPercentage - emailDataPercentage: ', emailDataPercentage);
      let emailDataPercentage = 0;
      if (emails && emails.length !== 0) emailDataPercentage = 100;
      // EMAIL - END

      // PHONE - START
      // const phoneDataConfig = this.$c('_profileConfiguration').comunicationPhone;
      // let phoneDataTotal = 0;
      // let phoneDataCompletition = 0;
      // phones.forEach(phone => {
      //   // email value
      //   let fieldPriority = getPriorityValue(phoneDataConfig['phone'].priority);
      //   phoneDataTotal += fieldPriority;
      //   console.log('completitionPercentage - field: ', 'phone', phoneDataConfig['phone'].priority, fieldPriority, phone.value, !!phone.value);
      //   if (phone.value) phoneDataCompletition += fieldPriority;
      //   // email type //TODO: check if  "communicationType" is the right value
      //   fieldPriority = getPriorityValue(phoneDataConfig['phoneType']);
      //   phoneDataTotal += fieldPriority;
      //   console.log('completitionPercentage - field: ', 'phoneType', phoneDataConfig['phoneType'], fieldPriority, phone.communicationType, !!phone.communicationType);
      //   if (phone.communicationType) phoneDataCompletition += fieldPriority;
      // });
      // const phoneDataUnit = 100 / phoneDataTotal;
      // const phoneDataPercentage = phoneDataCompletition * phoneDataUnit;
      let phoneDataPercentage = 0;
      if (phones && phones.length !== 0) phoneDataPercentage = 100;
      // PHONE - END

      // PROFILE PICTURE - START
      let profilePicturePercentage = 0;
      if (this.profileImg) profilePicturePercentage = 100;
      // PROFILE PICTURE - END

      // TOTAL PERSONAL DATA - START
      const personalDataSectionsPercentages = [personalInformationPercentage, addressesDataPercentage, emailDataPercentage, phoneDataPercentage, profilePicturePercentage];
      let personalDataSectionTotalPercentage = 0;
      personalDataSectionsPercentages.forEach(percentage => {
        personalDataSectionTotalPercentage += (100 / personalDataSectionsPercentages.length) / 100 * percentage;
      });
      // TOTAL PERSONAL DATA - END
      // PERSONAL DATA SECTION - END

      // ESIM SECTION - START
      const esimSectionTotalPercentage = 100;
      // ESIM SECTION - END

      // CONSENT SECTION - START
      const consentSectionTotalPercentage = 100;
      // CONSENT SECTION - END

      // PAY SECTION - START
      const paySectionTotalPercentage = 100;
      // PAY SECTION - END

      // DEALER SECTION - START
      let dealerSectionTotalPercentage = 0;

      const dealers = this.user.dealers;

      if(dealers?.find(dealer => 
        dealer.brand == this.brand && 
        dealer.isPreferredSalesDealer
      )) {
        dealerSectionTotalPercentage += 100;
      }
      // DEALER SECTION - END

      const sectionsPercentages = [
        personalDataSectionTotalPercentage
      ];
      let totalPercentage = 0;
      sectionsPercentages.forEach(percentage => {
        totalPercentage += (100 / sectionsPercentages.length) / 100 * percentage;
      });
      this.designCircle(Math.ceil(totalPercentage));
      return Math.ceil(totalPercentage);
    },
  },
  watch : {
    "user": {
      handler(newVal, oldVal) {
            console.log('utente cambiato');
            this.checkAndPreparePercentageBar();
      },
    },
  },
  async mounted() {
    if(this.$c('show_qr_section')){
      await this.qrManagement();
    }
    await this.getProfilePicture();
    this.checkAndPreparePercentageBar();
  },
  methods: {

    // Get the qrImage and the qrValue to display
    async qrManagement() {
      const cssReference = this.$c('_cssReference');
      const qrCodeLogo = await import(`@/assets/${cssReference}/light/qr-code-logo-${cssReference}-light.svg`);
      this.qrImage = qrCodeLogo.default;
      /* this.qrValue = JSON.stringify(
        {
          "gcid": this.user.gcid
        }
      ); */
    },


    /**
     * This function return the profile picture
    */

    getProfilePicture() {
      oneUtils.utils.showGlobalLoader();
      return oneUtils.httpClient.getProfilePicture(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then(res => {
        oneUtils.utils.hideGlobalLoader();
        this.profileImg = res;
        this.checkAndPreparePercentageBar();
      }).catch((err) => {
        oneUtils.utils.hideGlobalLoader();
      });
    },

    // start percentage bar functions

    checkAndPreparePercentageBar(){
      this.designCircle(this.completitionPercentage);
      
      this.profile_completion_message = this.$t('profile_picture_message_prefix') + this.completitionPercentage + this.$t('profile_picture_message_suffix');
    },


    designCircle(percentage){

        const el = document.getElementById('graph'); // get canvas

        if (!el) return;

        if(!(this.isProfilePercentageBarEnabled && this.$c('show_profile_picture')))return;

        const options = {
            percent:  percentage || 25,
            size: el.getAttribute('data-size') || 220,
            lineWidth: el.getAttribute('data-line') || 2,
            rotate: el.getAttribute('data-rotate') || 0
        }

        let canvas = el.getElementsByTagName('canvas')[0];
        if (!canvas) canvas = document.createElement('canvas');

        if (typeof(window.G_vmlCanvasManager) !== 'undefined') {
            window.G_vmlCanvasManager.initElement(canvas);
        }

        const ctx = canvas.getContext('2d');
        canvas.width = canvas.height = options.size;

        el.appendChild(canvas);

        ctx.translate(options.size / 2, options.size / 2); // change center
        ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

        //imd = ctx.getImageData(0, 0, 240, 240);
        const radius = (options.size - options.lineWidth) / 2;

        const drawCircle = function(color, lineWidth, percent) {
            percent = Math.min(Math.max(0, percent || 1), 1);
            ctx.beginPath();
            ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
            ctx.strokeStyle = color;
                ctx.lineCap = 'square'; // butt, round or square
            ctx.lineWidth = lineWidth
            ctx.stroke();
        };
        const brand = this._cssReference();
        let color = "#1C69D4";
        let backgroundCirleColor = "'#efefef'";
        if (this.isDarkmode()){
          color = "#347EE4";
        }
        if (brand == 'mini'){
          color = "#0085AC";
        }
        if (brand == 'toyota'){
          color = "#cc0000";
        }
        if (brand == 'rr'){
          color = "#6FDBC7";
          backgroundCirleColor = "";
        }
        if(backgroundCirleColor) drawCircle(backgroundCirleColor, options.lineWidth, 100 / 100);
        if(color) drawCircle(color, options.lineWidth, options.percent / 100);
    },


    isDarkmode() {
      const queryParams = oneUtils.utils.getQueryParams();
      if(queryParams){
        if(queryParams.isDarkmode && queryParams.isDarkmode === "true") return true;
        else if(queryParams.brand && (window.localStorage.getItem("oneid_darkmode_selected_" + queryParams.brand) === "true")) return window.localStorage.getItem("oneid_darkmode_selected_" + queryParams.brand);
      }
      return false;
    },


    _cssReference() {
        return (
          this.$c('_cssReference') ||
          oneUtils.properties.DEFAULT_FALLBACK_CSS_REFERENCE
        );
    },


    getPriorityValue(priority){
      if (priority === 'mandatory') return 2;
      if (priority === 'recommended') return 1;
      return 0;
    },


     // end percentage bar functions





  // Start QR  popup function
  
    closeQrAlert() {
      document.getElementById('show_alert_qr_code').focus();
      this.showQrAlert = false;
    },

    showAlertQrCode() {
      this.isLoading = true;
      this.showQrAlert = true;

      oneUtils.httpClient.getQRCode(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token).then(
        (response) => {
          let data = response.data;

          this.qrValue = JSON.stringify(data);
          
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          this.showQrAlert = false;

          // Error management
          oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
        }
      );
    },

    // End QR  popup function



    // Start profile picture upload popup function
    
    openPictureUploadPopup() {
      if (!this.$c('enable_profile_picture_edit')) return;
      this.isPictureUploadPopupOpened = true;
    },

    closePictureUploadPopup() {
      this.isPictureUploadPopupOpened = false;
      this.changePictureButtonLabel=false;
      this.isProfilePictureButtonDisabled=true;
      document.getElementById('upload_picture_button').focus();
    },

    closePictureUploadPopupClicked(){
      this.closePictureUploadPopup();
    },

    changeImageLoaderButtonLabel(){
      this.isProfilePictureButtonDisabled=false;
      this.changePictureButtonLabel=true;
    },

    /**
     * Save the cropped image
     */
    profileImageLoaded(croppedImg){
      setTimeout(() => {
        this.croppedImg = croppedImg;
        this.isProfilePictureButtonDisabled=false;
        this.changePictureButtonLabel=false;
        this.triggerLoadImage = false;
      }, 100);
    },

    /**
     * This function upload the profile picture
     * and manage the errors if presents
     */
    uploadProfilePicture(){
      oneUtils.utils.showGlobalLoader();
      this.triggerLoadImage = true;
      this.isLoading = true;
      setTimeout(() => {
        oneUtils.httpClient.uploadPicture(this.croppedImg, window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
          .then((res) => {
            oneUtils.utils.hideGlobalLoader();
            this.isLoading = false;
            this.getProfilePicture();
            oneUtils.utils.showMessage("SUCCESS", this.$t("profile_user_success"));
            this.closePictureUploadPopup();
          })
          .catch((err) => {
            oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
            this.closePictureUploadPopup();
            oneUtils.utils.hideGlobalLoader();
            this.isLoading = false;
          });
      }, 2000);
    },

    /**
     * This function delete the profile picture
     * and manage the errors if presents
     */
    deleteProfilePicture(){
      oneUtils.utils.showGlobalLoader();
      this.isLoading = true;
      oneUtils.httpClient.removePicture(window['$startupwebcomponent'] && window['$startupwebcomponent'].oneid_access_token)
        .then((res) => {
          oneUtils.utils.hideGlobalLoader();
          this.isLoading = false;
          this.profileImg=null
          this.checkAndPreparePercentageBar();
          oneUtils.utils.showMessage("SUCCESS", this.$t("profile_user_success"));
          this.closePictureUploadPopup();
        })
        .catch((err) => {
          oneUtils.utils.showMessage("WARNING", this.$t("generic_system_error_personal"));
          oneUtils.utils.hideGlobalLoader();
          this.isLoading = false;
          this.closePictureUploadPopup();
        });
    },

    // End profile picture upload popup function

  },
};
</script>
